import React from "react";
import PopoverEmployeeProfile from "./PopoverEmployeeProfile";
import "./EmployeeAvatar.css";
import { getDefaultUserAvatar } from "winslow-core";

export type EmployeeAvatarProps = {
  email: string | null;
  avatarUrl: string | null;
  name: string | null;
};

export const EmployeeAvatar = ({
  email,
  avatarUrl,
  name,
}: EmployeeAvatarProps) => {
  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
  };

  return (
    <>
      {email && name && avatarUrl && (
        <PopoverEmployeeProfile avatar={avatarUrl} name={name} email={email}>
          <div onClick={handleClick}>
            <img
              src={avatarUrl}
              alt={getDefaultUserAvatar(name)}
              className="author-avatar"
            />
          </div>
        </PopoverEmployeeProfile>
      )}
      {!email && (
        <img
          src={avatarUrl || undefined}
          alt={getDefaultUserAvatar(name)}
          className="author-avatar"
        />
      )}
    </>
  );
};
